import { DIAGNOSIS_UNLOCK_MODAL_PC_LOADING_HEIGHT_PX } from "../diagnosisUnlockModalShell";

/** Figma H5 `90772:39818` / PC `91062:21612` — 内容区与涟漪坐标（字面映射，非垂直居中）。 */
export const DIAGNOSIS_UNLOCK_LOADING_LAYOUT_FIGMA = {
  h5Page: "90772:39818",
  pcModal: "91062:21612",
  h5ContentFrame: "90772:39829",
  pcContentFrame: "91062:21616",
} as const;

/**
 * H5 393×852：`Frame 2147238399` y=235（含 Top block 后的固定偏移）。
 * PC 480×674：`Frame 2147238878` y=156（顶栏 close 下方固定偏移，**不是** modal 垂直居中）。
 *
 * 水平：两侧各 `contentSideInsetPx`（393 稿上 left=24、宽 345），宽屏用
 * `left-1/2 -translate-x-1/2` + `max-w-[345px]` 居中，避免 Samsung 等宽屏偏左。
 */
export const DIAGNOSIS_UNLOCK_LOADING_LAYOUT = {
  contentWidthPx: 345,
  contentSideInsetPx: 24,
  h5: {
    /** @deprecated 请用 {@link DIAGNOSIS_UNLOCK_LOADING_LAYOUT.contentSideInsetPx}；宽屏勿再写死 left */
    contentLeftPx: 24,
    contentTopPx: 235,
    rippleCenterX: 196,
    rippleCenterY: 426,
  },
  pc: {
    contentTopPx: 156,
    /** Figma `91062:21711` 在 content frame 内 y=-139、直径 623.5 → modal 内 ≈329 */
    rippleCenterY: 329,
    modalHeightPx: DIAGNOSIS_UNLOCK_MODAL_PC_LOADING_HEIGHT_PX,
    closeTopPx: 32,
    closeRightPx: 32,
  },
} as const;
